import { combineReducers } from 'redux';
import maps_modals from './index';

const appReducer = combineReducers({
  maps_modals: maps_modals,
});

export default appReducer;
